import {
  newModal,
  getAttachment,
  removeAttachment,
  closeModal,
} from "@js/helpers/state.js";
import {
  CE_MODAL_REMOVE_ATTACHMENT_SHOW,
  CE_MODAL_REMOVE_ATTACHMENT_CONFIRM,
} from "@js/actions/studio/campaign_content_section/modal_remove_attachment.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_REMOVE_ATTACHMENT_SHOW:
      let attachment = getAttachment(state, action.client_attachment_id);
      return newModal(state, "remove_attachment", {
        client_attachment_id: action.client_attachment_id,
        attachment_name: attachment.attachment_name,
      });

    case CE_MODAL_REMOVE_ATTACHMENT_CONFIRM:
      return removeAttachment(
        closeModal(state),
        state.modal.state.client_attachment_id,
      );

    default:
      return state;
  }
};
